import React from 'react';
import PropTypes from 'prop-types';
import AnimatedOverlay from './AnimatedOverlay/AnimatedOverlay';
import EmptyPlayerCross from './EmptyPlayerCross';
import styles from './NameContainer.module.css';

const NameContainer = ({ player, time }) => {
    const isEmpty = player.name === '...';
    
    const initial = (player?.name || '?').trim().charAt(0).toUpperCase();
    return (
        <div className={styles.container} style={{ backgroundColor: player.ready ? player.color : 'lightgrey' }}>
            <span className={styles.initial}>{initial}</span>
            {player.nowMoving ? <AnimatedOverlay time={time} /> : null}
            {isEmpty && <EmptyPlayerCross />}
        </div>
    );
};

NameContainer.propTypes = {
    player: PropTypes.object,
    time: PropTypes.number,
};

export default NameContainer;
